import { useInitialPublicData } from "../seo/PublicBootstrap.jsx";
import { useState, useEffect } from "react";
import { fetchListingBySlug } from "../services/api";

export function useListing(slug, options = {}) {
  const initial = useInitialPublicData("listing");
  const [listing, setListing] = useState(initial || null);
  const [loading, setLoading] = useState(!initial);
  const [error, setError] = useState(null);
  const { categorySlug = null, isEmbedPreview = false } = options;

  useEffect(() => {
    if (initial && initial.slug === slug) { setListing(initial); setLoading(false); setError(null); return undefined; }
    if (!slug) {
      setListing(null);
      setLoading(false);
      setError({ message: "Listing slug is required.", status: 400 });
      return undefined;
    }

    let cancelled = false;
    setLoading(true);
    setError(null);

    fetchListingBySlug(slug, { categorySlug, isEmbedPreview })
      .then((data) => {
        if (!cancelled) setListing(data);
      })
      .catch((err) => {
        if (!cancelled) {
          setListing(null);
          setError({ message: err?.message || "Unable to load this listing right now.", status: err?.status || 0 });
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => { cancelled = true; };
  }, [slug, categorySlug, isEmbedPreview, initial]);

  return { listing, setListing, loading, error };
}
